import { ScrollTrigger } from 'gsap/ScrollTrigger';

$(() => {
  let keyNumbersItem = document.querySelectorAll('.key-numbers');
  keyNumbersItem.forEach((block) => {
    let keyNumbersNumber = block.querySelectorAll('.key-numbers__number');
    let speed = block.dataset.animation_duration * 1000,
      speedInterval = speed / 100;

    keyNumbersNumber.forEach((item) => {
      let scrollFunc = () => {
        if (ScrollTrigger.isInViewport(item)) {
          let numberItem = item.querySelector('.number'),
            number = numberItem.dataset.number,
            index = 0,
            increment = Number.parseFloat(number) / speedInterval,
            intervalFunc,
            isFloat = Number.parseFloat(number) - Number.parseInt(number) > 0;

          intervalFunc = setInterval(() => {
            let currentNum = isFloat
              ? (index * increment).toFixed(1)
              : Math.round(index * increment);
            numberItem.textContent = Number.parseFloat(currentNum);

            if (Number.parseFloat(currentNum) === Number.parseFloat(number)) {
              clearInterval(intervalFunc);
            }

            index += 1;
          }, speedInterval);

          document.removeEventListener('scroll', scrollFunc);
        }
      };

      document.addEventListener('scroll', scrollFunc);
    });
  });
});
